import { notificationTypes } from '../../../constants/action-types';

export const clearNotifications = () => dispatch => {
  dispatch({
    type: notificationTypes.CLEAR_NOTIFICATIONS
  });
};
